import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { removeWorkspaceId } from '@/utils/token';
import { resetWsData } from '@/container/HomePage/slice/workspaceSlice';
import { updateAlertModal } from '@/container/HomePage/slice/settingSlice';
import ErrorComponent from '../../component/Error';
import { redirectToWsList } from '@/utils/redirect';

const ErrorPage = ({ errorTitle, errorDescription, errorCode = 403, showLogout = false, currentUser = {}, isClinicAccount = false, accountInfo = {} }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const clearAndNavigate = () => {
    removeWorkspaceId();
    dispatch(resetWsData());
    dispatch(updateAlertModal({
      open: false,
      title: undefined,
      content: undefined,
      hasAuth: false,
      code: undefined
    }));
  };

  return (
    <ErrorComponent
      errorTitle={errorTitle}
      errorDescription={errorDescription}
      errorCode={errorCode}
      buttonText={errorCode === 404 ? 'notFound.button' : 'error.go.workspace'}
      clickHandler={() => {
        clearAndNavigate();
        if (errorCode === 404) {
          navigate('/');
        } else {
          return redirectToWsList();
        }
      }}
      showLogout={showLogout}
      currentUser={currentUser}
      isClinicAccount={isClinicAccount}
      accountInfo={accountInfo}
    />
  );
};

export default ErrorPage;
